const defaultCameraOptions = () => ({
  panning: false,
  hover: true,
  minZoom: 0.5,
  maxZoom: 1.5,
  containerPadding: 30
});
const defaultEnvironment = () => ({
  reflectionUrl: "https://vortex.documents.cimpress.io/environments/default/reflection.jpg",
  shadowOptions: {
    canvasShadows: {
      enabled: true
    }
  }
});
// converts partialCameraOptions/partialEnvironmentOptions (user input) to vortex type PreviewConfig
// adds defaults
export const previewOptionsToPreviewConfig = _ref => {
  let {
    partialCameraOptions,
    partialEnvironmentOptions,
    canvas
  } = _ref;
  return {
    cameraOptions: Object.assign(Object.assign({}, defaultCameraOptions()), partialCameraOptions),
    environment: Object.assign(Object.assign(Object.assign({}, defaultEnvironment()), partialEnvironmentOptions), {
      shadowOptions: Object.assign(Object.assign({}, defaultEnvironment().shadowOptions), {
        canvasShadows: Object.assign(Object.assign({}, defaultEnvironment().shadowOptions.canvasShadows), partialEnvironmentOptions === null || partialEnvironmentOptions === void 0 ? void 0 : partialEnvironmentOptions.canvasShadows)
      })
    }),
    renderingOptions: {},
    canvas
  };
};